import { t, get } from "../i18n";

<Card title=(t("subheadings.aboutChmod"))>
  <p class="my-4">${t("what.aboutChmod")}</p>
  <p class="my-4">${t("what.aboutChmod2")}</p>
  <p class="my-4">${t("what.aboutChmod3")}</p>

  <h4 class="text-lg text-slate-300">${t('what.commonExamples')}</h4>
  <ul>
    <for|index, preset| in=(get("what.commonPresets"))>
      <li class="flex gap-2" key=(index)>
        <code class="text-green-300">${preset.number}</code>
        ${preset.description}
      </li>
    </for>
  </ul>

  <h4 class="text-lg text-slate-300 mt-4">Viewing File Permissions</h4>
  <p>
    To view the current permissions of a file or directory, you can use the <code>ls -l</code> command.<br>
    This will display the permissions in a human-readable format, showing the user, group, and other permissions.
    For example:
  </p>
  <code class="text-green-300 bg-slate-900/60 p-3 rounded-xl border border-gray-700 flex mt-3">ls -l [file-name]</code>

  <h4 class="text-lg text-slate-300 mt-4">Core Concepts</h4>
  <div class="flex flex-wrap gap-4 md:flex-nowrap mt-4">
    <for|index, card| in=(get("what.cards"))>
      <Card title=(card.heading) inner=(true) key=(index) class="w-full md:flex-1">
        ${card.description}
      </Card>
    </for>
  </div>
</Card>
